module.exports = __webpack_public_path__ + "img/established.eb3b96e4.svg";